<template>
  <v-container fluid>
    <v-row class="my-0">
      <!-- 1行目 -->
      <v-container fluid fill-height>
        <v-row class="my-0" align="center" justify="center" style="width: 70%">
          <v-col cols="4">
            <v-card class="mx-auto" max-width="400" color="#F8CED2" outlined @click="goOQCMenuPage()" v-if="canOQCOnly">
              <v-list-item three-line>
                <v-list-item-avatar tile size="80">
                  <v-icon size="80" color="#D64838">mdi-text-box-check</v-icon>
                </v-list-item-avatar>
                <v-list-item-content class="ml-5">
                  <div class="overline mb-4"></div>
                  <v-list-item-title class="headline mb-1">{{ $t('ELE0072') }}</v-list-item-title>
                  <v-list-item-subtitle>{{ $t('MSG0032') }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-card>
          </v-col>
          <v-col cols="4">
            <v-card class="mx-auto" max-width="400" color="#BBD9F3" outlined @click="goIQCMenuPage()" v-if="canIQC">
              <v-list-item three-line>
                <v-list-item-avatar tile size="80">
                  <v-icon size="80" color="#1976D2">mdi-text-box-check-outline</v-icon>
                </v-list-item-avatar>
                <v-list-item-content class="ml-5">
                  <div class="overline mb-4"></div>
                  <v-list-item-title class="headline mb-1">{{ $t('ELE0073') }}</v-list-item-title>
                  <v-list-item-subtitle>{{ $t('MSG0033') }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-card>
          </v-col>
        </v-row>
      </v-container>

      <!-- 2行目 -->
      <v-container fluid fill-height>
        <v-row class="my-0" align="center" justify="center" style="width: 70%">
          <v-col cols="4">
            <v-card
              class="mx-auto"
              max-width="400"
              color="#FCF4A1"
              outlined
              @click="goMasterMenuPage()"
              v-if="canMasterMaintenance"
            >
              <v-list-item three-line>
                <v-list-item-avatar tile size="80">
                  <v-icon size="80" color="#948D2B">mdi-database-edit</v-icon>
                </v-list-item-avatar>
                <v-list-item-content class="ml-5">
                  <div class="overline mb-4"></div>
                  <v-list-item-title class="headline mb-1">{{ $t('ELE0062') }}</v-list-item-title>
                  <v-list-item-subtitle>{{ $t('MSG0034') }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-card>
          </v-col>
          <v-col cols="4">
            <v-card class="mx-auto" max-width="400" color="#C9E0A7" outlined @click="goSignout()">
              <v-list-item three-line>
                <v-list-item-avatar tile size="80">
                  <v-icon size="80" color="#3A8A3E">mdi-logout</v-icon>
                </v-list-item-avatar>
                <v-list-item-content class="ml-5">
                  <div class="overline mb-4"></div>
                  <v-list-item-title class="headline mb-1">{{ $t('ELE0071') }}</v-list-item-title>
                  <v-list-item-subtitle>{{ $t('MSG0035') }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-row>

    <system-footer />
  </v-container>
</template>

<script>
import { API } from '@/plugins/api'
import APIUtils from '@/mixin/api-utils.js'
import Message from '@/mixin/message-utils.js'
import Loading from '@/mixin/loading-utils.js'
import SystemFooter from '@/components/atoms/base/header-footer/Footer'

export default {
  name: 'TopMenuPage',

  mixins: [APIUtils, Message, Loading],

  components: {
    SystemFooter,
  },

  computed: {
    canOQCOnly: {
      get() {
        return this.$store.getters.canOQCOnly
      },
    },
    canIQC: {
      get() {
        return this.$store.getters.canIQC
      },
    },
    canMasterMaintenance: {
      get() {
        return this.$store.getters.canMasterMaintenance
      },
    },
  },

  methods: {
    goOQCMenuPage() {
      this.$router.push({ name: 'OQCMenu' }).catch(() => {})
    },
    goIQCMenuPage() {
      this.$router.push({ name: 'IQCMenu' }).catch(() => {})
    },
    goMasterMenuPage() {
      this.$router.push({ name: 'MasterMenu' }).catch(() => {})
    },
    async goSignout() {
      await this.$store.dispatch('doSignOut')
      this.$router.push({ name: 'SignIn' }).catch(() => {})
    },
    async setUserAttr() {
      const userAttr = await API.post('/master/users/attributes', {
        userCd: this.$store.getters.cognito.username,
        mail: this.$store.getters.cognito.email,
      })
      await this.$store.dispatch('doSetUserAttr', userAttr)
    },
  },
  async mounted() {
    try {
      this.startLoading()

      const redirectUrl = this.$store.getters.redirectUrl
      await this.$store.dispatch('doSetRedirectUrl', { redirectUrl: '' })
      await this.setUserAttr()
      if (redirectUrl) {
        this.$router.push({ path: redirectUrl }).catch(() => {})
      }
    } catch (error) {
      await this.$store.dispatch('doSetUserAttr', null)
      this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0002', { p0: this.$t('ELE0043') })))
    } finally {
      this.stopLoading()
    }
  },
}
</script>
